import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const NavigationProgress = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const isFirst = useRef(true);

  useEffect(() => {
    // Skip initial mount
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 500);
    return () => clearTimeout(t);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 left-0 z-[60] h-[3px] w-full pointer-events-none"
      aria-hidden="true"
    >
      <div className="h-full bg-accent animate-progress-bar" />
    </div>
  );
};

export default NavigationProgress;
